export const FETCH_DISCLOSURES = 'FETCH_DISCLOSURES';
export const FETCH_DISCLOSURES_SUCCESS = 'FETCH_DISCLOSURES_SUCCESS';
export const FETCH_DISCLOSURES_FAILURE = 'FETCH_DISCLOSURES_FAILURE';
